/* AED Professionals — AED Adviser logic (theme asset).
   Loads from the theme so it does not depend on GemPages running inline scripts.
   Safe site-wide: does nothing unless the .aedp-adviser markup is on the page.
   Pair with the <div class="aedp-adviser">...</div> block in GemPages. */
(function(){
  var tries = 0;
  function boot(){
    var root = document.querySelector('.aedp-adviser');
    if(!root || !root.querySelector('#aedpAdvQuiz')){
      if(tries++ < 200){ setTimeout(boot,60); }
      return;
    }
    if(root.getAttribute('data-aedp-ready')==='1'){ return; }
    root.setAttribute('data-aedp-ready','1');

    var STORE = "https://aedprofessionals.com/products/";
    /* Product handles verified against the live catalog. */
    var P = {
      onsite:{brand:"Philips",name:"HeartStart OnSite",price:1687,handle:"philips-heartstart-onsite-aed",
        tags:["No prescription needed","Simplest to use","Great for home"],
        why:"The OnSite is FDA-cleared for over-the-counter purchase, so there is no prescription hurdle. Its plain-language coaching is the most beginner-friendly on the market \u2014 ideal when an untrained person may be the one responding."},
      frx:{brand:"Philips",name:"HeartStart FRx",price:2427,handle:"philips-heartstart-frx-aed",
        tags:["Rugged (IP55)","Infant/child key","Trained-responder favorite"],
        why:"Built tough for first responders and active settings, the FRx survives drops, dust, and water, and switches to pediatric mode with a simple key \u2014 no separate pads to stock."},
      zollplus:{brand:"ZOLL",name:"AED Plus",price:2082,handle:"zoll-aed-plus",
        tags:["Real CPR Help coaching","Low consumable cost","All-around value"],
        why:"The AED Plus is the workhorse all-rounder. Its Real CPR Help coaches compression depth and rate in real time, and its 5-year pads plus inexpensive battery pack make it one of the cheapest units to keep ready over time."},
      zoll3:{brand:"ZOLL",name:"AED 3",price:2399,handle:"zoll-aed-3",
        tags:["Universal adult+child pads","Real-time CPR feedback","Wi-Fi ready"],
        why:"The AED 3 uses one Uni-padz electrode for both adults and children \u2014 no swapping or extra pediatric pads to expire. Add full-color rescue guidance and CPR feedback and it is a standout for schools and public spaces."},
      lifeline:{brand:"Defibtech",name:"Lifeline AED",price:1523,handle:"defibtech-lifeline-aed",
        tags:["Budget-friendly","7-year battery","Simple & reliable"],
        why:"The Lifeline pairs a low entry price with a long 7-year battery, keeping both upfront and long-term costs down. A clean, no-frills choice for organizations watching the budget."},
      lifelineview:{brand:"Defibtech",name:"Lifeline VIEW",price:2086,handle:"defibtech-lifeline-view-aed",
        tags:["Full-color video","Visual rescue guidance","Clinic-friendly"],
        why:"The VIEW is the only AED with full-motion video instructions on a color screen \u2014 excellent where a visual walkthrough reassures responders, like clinics and offices."},
      g5:{brand:"Cardiac Science",name:"Powerheart G5",price:2157,handle:"cardiac-science-powerheart-g5-aed",
        tags:["Fast shock delivery","Dual auto/semi mode","Rescue-ready light"],
        why:"The G5 delivers one of the fastest shocks after analysis and offers both fully-automatic and semi-automatic models, with intelligent CPR feedback. A strong pick for medical and professional settings."},
      hs350:{brand:"HeartSine",name:"Samaritan PAD 350P",price:1411,handle:"heartsine-samaritan-pad-350p-aed",
        tags:["No prescription needed","Smallest & most rugged","Single Pad-Pak"],
        why:"The lightest, most portable AED here, the 350P is OTC-cleared and carries a high IP56 dust/water rating. Its single Pad-Pak combines battery and pads, so there is only one consumable to track \u2014 perfect for home, travel, and tough spots."},
      hs450:{brand:"HeartSine",name:"Samaritan 450P",price:1761,handle:"heartsine-samaritan-450p-aed-with-cpr-rate-advisor",
        tags:["CPR Rate Advisor","Rugged & portable","Single Pad-Pak"],
        why:"All the portability and ruggedness of the 350P, plus the CPR Rate Advisor that coaches compression rate in real time \u2014 a compact unit that punches above its weight."},
      cr2:{brand:"Physio-Control / Stryker",name:"LIFEPAK CR2",price:2256,handle:"physio-control-lifepak-cr2-aed",
        tags:["cprINSIGHT analysis","Child mode (no extra pads)","Wi-Fi / LTE ready"],
        why:"The CR2's cprINSIGHT technology analyzes the heart while you keep doing compressions, cutting pause time. Built-in child mode means no separate pediatric pads, and optional connectivity suits large managed programs."}
    };

    var QORDER = ["setting","users","ped","budget","cpr"];
    var answers = {}, step = 0;

    function score(){
      var s = {}; Object.keys(P).forEach(function(k){ s[k]=0; });
      function add(k,n){ if(s[k]!==undefined) s[k]+=n; }
      switch(answers.setting){
        case "home": add("onsite",3);add("hs350",3);add("hs450",2);add("lifeline",1);add("zollplus",1);break;
        case "business": add("zollplus",3);add("onsite",2);add("lifeline",2);add("g5",2);add("lifelineview",1);break;
        case "school": add("zoll3",3);add("cr2",3);add("zollplus",2);add("frx",2);break;
        case "gym": add("zollplus",3);add("hs450",2);add("cr2",2);add("zoll3",2);break;
        case "worship": add("lifeline",3);add("zollplus",2);add("onsite",2);add("hs350",1);break;
        case "public": add("cr2",3);add("zoll3",3);add("zollplus",2);add("g5",1);break;
        case "medical": add("g5",3);add("zoll3",2);add("lifelineview",2);add("frx",2);break;
        case "outdoor": add("frx",3);add("hs350",2);add("zollplus",2);add("cr2",2);break;
      }
      switch(answers.users){
        case "lay": add("onsite",2);add("hs350",2);add("zollplus",2);add("lifeline",1);break;
        case "some": add("zollplus",2);add("zoll3",2);add("cr2",1);add("g5",1);break;
        case "pro": add("frx",2);add("cr2",2);add("g5",2);add("zoll3",1);break;
        case "mixed": add("zollplus",2);add("zoll3",1);add("onsite",1);add("cr2",1);break;
      }
      switch(answers.ped){
        case "often": add("zoll3",3);add("cr2",3);add("frx",1);break;
        case "some": add("zoll3",2);add("cr2",2);add("onsite",1);add("frx",1);add("zollplus",1);add("g5",1);add("hs350",1);break;
      }
      switch(answers.budget){
        case "upfront": add("hs350",3);add("lifeline",3);add("onsite",2);break;
        case "tco": add("zollplus",3);add("lifeline",2);add("onsite",1);add("hs350",1);break;
        case "features": add("cr2",3);add("zoll3",3);add("g5",2);add("frx",2);break;
      }
      switch(answers.cpr){
        case "yes": add("zollplus",3);add("zoll3",3);add("cr2",3);add("hs450",2);add("g5",1);break;
        case "nice": add("zollplus",1);add("zoll3",1);add("cr2",1);add("hs450",1);break;
        case "no": add("onsite",1);add("lifeline",1);add("hs350",1);break;
      }
      if(answers.setting==="home"){ add("onsite",2);add("hs350",2); }
      return Object.keys(s).map(function(k){return [k,s[k]];}).sort(function(a,b){ return b[1]-a[1] || P[a[0]].price-P[b[0]].price; });
    }

    var steps = root.querySelectorAll(".aedp-step");
    var progress = root.querySelector("#aedpAdvProgress");
    steps.forEach(function(){ progress.insertAdjacentHTML("beforeend","<i></i>"); });
    var dots = progress.querySelectorAll("i");
    var nextBtn = root.querySelector("#aedpAdvNext");
    var backBtn = root.querySelector("#aedpAdvBack");

    function renderStep(){
      steps.forEach(function(s){ s.classList.toggle("aedp-active", +s.dataset.step===step); });
      dots.forEach(function(d,i){ d.classList.toggle("aedp-done", i<=step && answers[QORDER[i]]); });
      backBtn.style.visibility = step===0 ? "hidden" : "visible";
      nextBtn.textContent = step===steps.length-1 ? "See My Recommendation" : "Next";
      nextBtn.disabled = !answers[QORDER[step]];
    }

    function showResult(){
      var ranked = score();
      var top = P[ranked[0][0]], run = P[ranked[1][0]];
      root.querySelector("#aedpAdvQuiz").style.display = "none";
      root.querySelector("#aedpAdvResult").classList.add("aedp-active");
      root.querySelector("#aedpAdvBrand").textContent = top.brand;
      root.querySelector("#aedpAdvName").textContent = top.name;
      root.querySelector("#aedpAdvPrice").textContent = "From $" + top.price.toLocaleString();
      root.querySelector("#aedpAdvWhy").textContent = top.why;
      root.querySelector("#aedpAdvTags").innerHTML = top.tags.map(function(t){return "<span>"+t+"</span>";}).join("");
      root.querySelector("#aedpAdvLink").href = STORE + top.handle;
      root.querySelector("#aedpAdvRunName").textContent = run.brand + " " + run.name;
      root.querySelector("#aedpAdvRunWhy").textContent = run.tags.join(" \u00b7 ");
      root.querySelector("#aedpAdvRunLink").href = STORE + run.handle;
      dots.forEach(function(d){ d.classList.add("aedp-done"); });
    }

    root.querySelectorAll(".aedp-opts").forEach(function(group){
      group.addEventListener("click", function(e){
        var opt = e.target.closest(".aedp-opt"); if(!opt) return;
        group.querySelectorAll(".aedp-opt").forEach(function(o){ o.classList.remove("aedp-sel"); });
        opt.classList.add("aedp-sel");
        answers[group.dataset.q] = opt.dataset.val;
        nextBtn.disabled = false;
        dots[step].classList.add("aedp-done");
      });
    });
    nextBtn.addEventListener("click", function(){
      if(step===steps.length-1){ showResult(); return; }
      step++; renderStep();
    });
    backBtn.addEventListener("click", function(){ if(step>0){ step--; renderStep(); } });
    root.querySelector("#aedpAdvRestart").addEventListener("click", function(){
      step=0; answers={};
      root.querySelectorAll(".aedp-opt").forEach(function(o){ o.classList.remove("aedp-sel"); });
      root.querySelector("#aedpAdvResult").classList.remove("aedp-active");
      root.querySelector("#aedpAdvQuiz").style.display = "block";
      renderStep();
    });

    renderStep();
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',boot); } else { boot(); }
})();